import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { LANG_STORAGE_KEY } from "@/lib/lang";

import enUS from "./locales/en-US.json";
import esUS from "./locales/es-US.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "en-US": { translation: enUS },
      en: { translation: enUS },
      "es-US": { translation: esUS },
      es: { translation: esUS },
    },
    fallbackLng: "en-US",
    supportedLngs: ["en-US", "es-US"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ["localStorage"],
    },
    returnEmptyString: false,
  });

// `<html lang>` follows the active language on EVERY page (2026-10-28).
//
// It used to be set only by `useLanguage`, which mounts with the navbar and the
// mobile menu; the old /onboarding had neither, so it showed Spanish under
// `lang="en"` and Chrome translated it "from English": "Sugerir categorías"
// came out as "Categorías de azúcar". Owned here, where the language changes.
const syncHtmlLang = (lng) => {
  document.documentElement.lang = String(lng || "").toLowerCase().startsWith("es") ? "es-US" : "en-US";
};
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang(i18n.language);

export default i18n;
